import React from "react";
import { Col } from "reactstrap";
import classNames from "classnames";

export default function ColPrompt({
  title,
  sizePRP,
  alignPRP,
  classNamePRP,
  headerPRP,
}) {
  if (headerPRP) {
    return (
      <Col
        xs={sizePRP || "3"}
        className={
          classNamePRP
            ? classNames(classNamePRP, { "text-white": true })
            : "px-4 text-white"
        }
      >
        <h4 style={{ textAlign: [alignPRP || "left"] }}>{title}</h4>
      </Col>
    );
  } else {
    return (
      <Col
        xs={sizePRP || "3"}
        className={
          classNamePRP
            ? classNames(classNamePRP, { "text-white": true })
            : "px-4 text-white"
        }
        style={{paddingRight: "0px"}}
      >
        <h5 style={{ textAlign: [alignPRP || "left"] }}>{title}</h5>
      </Col>
    );
  }
}
